import { NgIf }                                                    from '@angular/common';
import { Component, Inject, OnInit }                               from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule }                                         from '@angular/material/button';
import { MatCheckboxModule }                                       from '@angular/material/checkbox';
import { ErrorStateMatcher }                                       from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef }          from '@angular/material/dialog';
import { MatIconModule }                                           from '@angular/material/icon';
import { MatInputModule }                                          from '@angular/material/input';
import { MatProgressBarModule }                                    from '@angular/material/progress-bar';
import { LetDirective, PushPipe }                                  from '@ngrx/component';
import { Store }                                                   from '@ngrx/store';
import { FeatureSpinnerEnum }                                      from '@shared/enums/featureSpinner.enum';
import { cloneDeep }                                               from '@shared/helper/LDHelper';
import { NgxMaskDirective, provideNgxMask }                        from 'ngx-mask';
import { debounceTime, filter }                                    from 'rxjs/operators';
import { CustomValidatorsService }                                 from 'src/app/shared/errors/CustomValidatorsService';
import { saveUserAndCreateBilan }                                  from 'src/app/shared/ngrx/store/actions/bilan.actions';
import { selectLoadingByKey }                                      from 'src/app/shared/ngrx/store/selectors/spinner.selector';
import { IAppState }                                               from 'src/app/shared/ngrx/store/state/app.state';
import { SpinnerPipe }                                             from 'src/app/shared/pipe/shared/spinner.pipe';
import { TrackingService }                                         from 'src/app/shared/services/trackingService/tracking.service';
import { LocalStorageUtil }                                        from 'src/app/shared/utils/localStorageUtil';
import { MyErrorStateMatcher }                                     from '../../../main/steps/step-one/step-one.component';

@Component ({
              selector:    'app-rappel-conseiller',
              templateUrl: './rappel-conseiller.component.html',
              styleUrls:   ['./rappel-conseiller.component.scss'],
              standalone:  true,
              imports:     [
                MatButtonModule,
                MatIconModule,
                ReactiveFormsModule,
                MatDialogModule,
                MatInputModule,
                NgIf,
                NgxMaskDirective,
                MatCheckboxModule,
                PushPipe,
                MatProgressBarModule,
                LetDirective,
                SpinnerPipe,
              ],
              providers:   [provideNgxMask ()],
            })
export class RappelConseillerComponent implements OnInit {
  public formgroup: FormGroup;
  public matcher: ErrorStateMatcher;
  public confirm: boolean = false;

  public selectLoadingSaveBilans$ = this._store.select (selectLoadingByKey (FeatureSpinnerEnum.SAVE_BILAN));

  constructor (private _fb: FormBuilder,
               protected _store: Store<IAppState>,
               public dialogRef: MatDialogRef<RappelConseillerComponent>, @Inject (MAT_DIALOG_DATA) public data: any,
               private trackingService: TrackingService,
  ) {
    this.formgroup = this.getFormGroup ();
    this.matcher   = new MyErrorStateMatcher ();
  }

  ngOnInit (): void {
    this.trackingService.init ();
    this.trackingService.trackEtapeRappelConseille ();

    this.selectLoadingSaveBilans$.pipe (
      filter (v => (v === 'STOP' && this.confirm)),
      debounceTime (400),
    ).subscribe (() => {
      this.dialogRef.close ({ check: true });
    });
  }

  private getFormGroup () {
    return this._fb.group ({
                             email:     [
                               '', Validators.compose ([Validators.required, Validators.email]),
                             ],
                             telephone: [
                               '',
                               Validators.compose ([
                                                     Validators.required,
                                                     CustomValidatorsService.telValidator,
                                                   ]),
                             ],
                             rappel:    [
                               '', Validators.compose ([Validators.required]),
                             ],
                           });
  }


  async next () {
    this.confirm          = true;
    const userUpdated     = cloneDeep (this.data.user);
    userUpdated.email     = this.formgroup.get ('email').value;
    userUpdated.telephone = this.formgroup.get ('telephone').value;
    this.trackingService.trackEtapeRappelConseilleConfirm (userUpdated.email, userUpdated.telephone);
    if (LocalStorageUtil.hasUserID ()) {
      userUpdated.id = LocalStorageUtil.getUserId ();
    }
    let bilanId = null;
    if (LocalStorageUtil.hasKeyBilan ()) {
      bilanId = LocalStorageUtil.getKeyBilan ().toString ();
    }

    const conseiller = this.formgroup.value;
    if (!!conseiller && !!conseiller?.email) {
      this._store.dispatch (saveUserAndCreateBilan ({
                                                      user:             userUpdated,
                                                      bilanId:          bilanId,
                                                      rappelConseiller: conseiller,
                                                      produits:         this.data.produits,
                                                      fileNamePdf:      this.data.fileNamePdf,
                                                    }));
    }
  }

  closeDialog () {
    this.dialogRef.close ({ check: false });
  }
}
